var _defs, _g, _g2, _g3, _g4, _g5, _g6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #00a9d4;\n      }\n\n      .st1, .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #00acd1;\n        opacity: .5;\n      }\n\n      .st4, .st5 {\n        fill: #0092e8;\n      }\n\n      .st5, .st6, .st7 {\n        opacity: .4;\n      }\n\n      .st8 {\n        fill: #001a41;\n      }\n\n      .st9 {\n        fill: #00a0dc;\n      }\n\n      .st10 {\n        fill: #00b1c4;\n      }\n\n      .st11 {\n        opacity: .8;\n      }\n\n      .st12 {\n        fill: #00cab6;\n      }\n\n      .st13, .st14 {\n        fill: #0099e2;\n      }\n\n      .st14, .st2 {\n        opacity: .3;\n      }\n\n      .st15 {\n        fill: #00d8ae;\n      }\n\n      .st6, .st16, .st17 {\n        fill: #0093e7;\n      }\n\n      .st17 {\n        opacity: .6;\n      }\n\n      .st18 {\n        fill: #00cdb3;\n      }\n\n      .st19 {\n        fill: #008ced;\n      }\n\n      .st20 {\n        fill: #0088f1;\n      }\n\n      .st21 {\n        fill: #00c4bb;\n      }\n\n      .st22 {\n        fill: #00b6c8;\n      }\n\n      .st7 {\n        fill: #00a4d9;\n      }\n\n      .st23 {\n        fill: #006ad3;\n      }\n\n      .st24 {\n        fill: #caf5ff;\n      }\n\n      .st25 {\n        fill: #00ceb2;\n      }\n\n      .st26 {\n        fill: #bae8ee;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1423.32,467.91l-3.25-3.87c.89-.76,91.03-75.78,221.29-113.84,120.35-35.17,300.56-45.12,475.55,107.12l-3.32,3.82c-173.21-150.69-351.53-140.89-470.65-106.13-129.28,37.72-218.73,112.15-219.62,112.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2813.37,1440.22c-18.8-200.3-96.44-352.33-297.59-463.83-59.32-32.88-133.6-48.95-169.17-106.71-35.31-57.34-22.2-130.57-29.19-197.56-17.95-171.85-182.18-304.73-354-322.92-171.83-18.19-342.76,59.63-473.28,172.86-97.93,84.96-183.71,193.41-307.1,233.19-203.48,65.61-424.88-80.74-633.69-34.85-112.36,24.69-206.62,103.36-275.46,195.54-115.19,154.25-143.9,349.27-108.67,538.53,19.27,103.53,66.42,208.46,133.99,289.05l2421.1-5.06c70.79-70.79,101.12-212.36,93.06-298.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 1078.7,
    cy: 481.15,
    r: 187.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 1390.51,
    cy: 314.28,
    r: 77.53,
    transform: "translate(185.04 1075.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 2577.05,
    cy: 855.3,
    r: 77.53,
    transform: "translate(150.01 2072.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2801.75,1741.33l-4.46-2.37c90.94-171.42,100.57-355.7,26.42-505.56-77.96-157.56-237.09-263.57-448.06-298.5l.83-4.99c212.62,35.2,373.06,142.18,451.76,301.24,74.89,151.34,65.24,337.29-26.48,510.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M313.36,1748.6c-109.55-117.97-181.83-260.05-209.04-410.87-25.33-140.44-8.96-279.79,46.09-392.38,85.05-173.94,249.65-263.56,451.54-245.94l-.44,5.04c-199.73-17.45-362.48,71.17-446.56,243.12-54.58,111.63-70.8,249.87-45.66,389.26,27.03,149.87,98.88,291.07,207.76,408.34l-3.7,3.44Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 379.26,
    y: 1376.95,
    width: 650.57,
    height: 366.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 379.26,
    y: 1376.95,
    width: 233.1,
    height: 366.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 721.46,
    y: 1391.22,
    width: 89.21,
    height: 60.68,
    transform: "translate(-655.49 2187.62) rotate(-90)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 901.33,
    y: 977.98,
    width: 1074.65,
    height: 765.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2080.62,707.46h-198.81v-181.47c0-36.61,29.68-66.29,66.29-66.29,18.3,0,34.89,7.43,46.87,19.42,11.83,11.83,19.26,28.21,19.42,46.26v.61l-.05,115.18c0,.56,0,1.16.05,1.72v3.49l.2-.1c2.58,34.23,31.15,61.18,66.03,61.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2146.86,601.12v40.1c0,18.3-7.38,34.89-19.42,46.82-11.93,12.03-28.52,19.42-46.82,19.42-34.89,0-63.46-26.95-66.03-61.18l132.27-45.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1948.1,459.7c-1.42,0-2.78.05-4.15.15-.91.05-1.77.1-2.63.2-.96.1-1.87.2-2.83.35-.56.05-1.11.15-1.67.25-.71.1-1.42.25-2.07.4-1.01.2-1.97.4-2.98.66-1.42.35-2.83.76-4.25,1.26-.71.2-1.42.46-2.07.71-.66.2-1.37.51-2.02.76-.96.35-1.87.76-2.78,1.21-.81.35-1.62.71-2.43,1.16-.2.1-.46.2-.71.35-.71.35-1.42.76-2.12,1.16-2.78,1.57-5.46,3.34-7.94,5.31-.71.56-1.47,1.16-2.12,1.72-.81.66-1.52,1.31-2.28,2.02-.76.71-1.47,1.42-2.17,2.12-1.97,2.02-3.84,4.15-5.56,6.42-.76,1.01-1.47,1.97-2.17,2.98-2.22,3.39-4.15,6.93-5.81,10.67-.4.91-.76,1.87-1.16,2.83-1.06,2.88-1.97,5.87-2.68,8.9-.2,1.06-.4,2.07-.61,3.08-.35,2.07-.66,4.2-.81,6.32v929.85h-886.21v-887.52c0-57.09,46.26-103.35,103.35-103.35h848.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 1100.62,
    y: 554.45,
    width: 672.48,
    height: 35.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 1100.62,
    y: 658.11,
    width: 620.37,
    height: 35.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 1100.62,
    y: 761.76,
    width: 587.67,
    height: 35.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 1100.62,
    y: 865.41,
    width: 672.48,
    height: 35.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 1360.49,
    y: 970.33,
    width: 364.58,
    height: 35.39
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1433.87,1169.07c-4.02,0-7.73-1.37-10.27-4.87-3.12-4.32-2.9-10.23-2.75-14.14l3.43-91.46,5.05.19-3.43,91.46c-.16,4.26-.14,8.31,1.8,10.99,4.3,5.93,14.63.8,16.66-.29,10.18-5.46,17.49-15.74,24.56-25.68,7.86-11.05,15.99-22.47,28.28-27.84,7.29-3.19,12.66,1.49,16.97,5.22,2.45,2.12,4.76,4.12,7.2,4.85,6.43,1.9,12.83.24,19.6-1.54,5.98-1.57,12.19-3.2,18.56-2.21,5.83.89,10.53,3.21,15.08,5.46,6.72,3.32,12.53,6.19,20.93,4.15,11.58-2.79,22.34-9.38,32.74-15.76,3.02-1.85,6.02-3.69,9.06-5.46,11.69-6.79,29.27-15.36,46.75-11.35l-1.13,4.93c-15.77-3.6-32.14,4.43-43.09,10.8-3,1.74-5.97,3.57-8.96,5.39-10.74,6.58-21.84,13.39-34.2,16.36-10.19,2.45-17.4-1.09-24.35-4.53-4.2-2.07-8.55-4.22-13.6-4.99-5.34-.81-10.77.61-16.52,2.1-7.15,1.87-14.51,3.8-22.32,1.5-3.49-1.04-6.34-3.5-9.08-5.88-4.51-3.91-7.48-6.21-11.64-4.41-11.01,4.81-18.38,15.17-26.18,26.14-7.41,10.41-15.06,21.18-26.29,27.2-3.99,2.14-8.62,3.68-12.88,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1882.07,1010.02v440.55h-886.21v-478.93l276.83,230.31c15.27,12.74,35.29,17.6,55.01,14.81,5.71-.81,11.58-1.11,17.44-.96l188.7,5.31c6.52.2,12.99,1.01,19.31,2.38,19.57,4.25,40.05.35,56.17-11.58l272.73-201.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "1305.4 1295.2 1298.02 1303.39 964.51 1673.2 901.36 1743.18 901.36 977.97 1305.4 1295.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "1975.99 977.98 1571.92 1295.2 1975.99 1743.16 1975.99 977.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1298.02,1303.39l-333.51,369.81-63.15,13.9v-135.96c166.7-119.48,353.74-258.02,396.46-261l.2,13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1579.32,1303.39l333.51,369.81,63.15,13.9v-135.96c-166.7-119.48-353.74-258.02-396.46-261l-.2,13.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1975.99,1743.16H901.33l.2-100.66,370.3-335.93c19.43-17.63,44.73-27.39,70.96-27.39h188.78c25.84,0,50.79,9.48,70.12,26.63l375.34,333.22-1.05,104.14Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1904.57,
    cy: 1558.61,
    r: 184.55,
    transform: "translate(-544.27 1803.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 1960.18,
    cy: 1558.61,
    r: 184.55,
    transform: "translate(-527.98 1842.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1956.23,1658.61c-8.76,0-17.15-3.67-23.16-10.3l-65.29-72.1c-5.62-6.21-5.15-15.8,1.06-21.42,6.22-5.62,15.81-5.15,21.42,1.06l65.29,72.09c.13.14.38.38.88.31.52-.08.65-.39.73-.57l70.28-160c3.37-7.67,12.3-11.15,19.99-7.79,7.67,3.37,11.16,12.32,7.79,19.99l-70.28,160c-4.29,9.76-13.12,16.61-23.64,18.31-1.69.28-3.39.41-5.08.41Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "679.27 1274.97 685.17 1376.94 841.91 1376.94 771.12 1318.79 766.91 1274.97 739.1 1248 679.27 1274.97"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "491.34 1229.46 466.06 1320.48 595 1376.94 557.07 1290.98 566.34 1252.22 534.32 1210.08 491.34 1229.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M541.06,777.77s-15.17,63.2-10.11,202.25c0,0-44.66,155.9-39.61,249.44l75,22.75c39.29-87.31,71.61-171.31,88.79-248.12,8.57-27.16,8.41-56.33-.46-83.39l-36.08-110.07-77.53-32.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M778.79,982.92l-11.88,292.05h-87.62c-22.85-95.11-31.35-176.31-34.33-230.72-2.48-45.86-1.06-72.66-1.06-72.66-56.33-66.49-89.8-114.52-109.27-150.07-28.92-52.74-27.15-78.12-23.92-96.02,4.35-23.81,19.82-54.66,30.29-73.62,5.87-10.52,10.16-17.39,10.16-17.39l146.63,47.23-17.49,63.25-.3,1.06c-2.63,9.51-1.31,19.72,3.59,28.26l76.91,133.94c12.99,22.65,19.37,48.54,18.3,74.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M733.2,1276.87s-.08,0-.12,0c-1.05-.06-1.84-.97-1.77-2.01.18-2.93,18.26-293.32-3.2-339.54-3.77-8.12-10.16-18.48-17.56-30.48-30.97-50.2-82.82-134.23-71.93-255.33.09-1.04.99-1.83,2.06-1.72,1.04.09,1.81,1.01,1.72,2.06-10.77,119.84,40.66,203.19,71.38,252.99,7.47,12.1,13.91,22.55,17.78,30.87,21.86,47.09,4.3,329.38,3.54,341.37-.06,1.01-.9,1.78-1.89,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M697.79,681.72l-17.49,63.25c-67.45-27.76-116.04-69.98-139.3-93.09,5.87-10.52,10.16-17.39,10.16-17.39l146.63,47.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M722.57,1322.88l-1.49-25.33,48.32-.87c1.25.02,1.91.81,1.93,1.86.02,1.05-.81,1.91-1.86,1.93l-44.37.8,1.04,17.65,44.9-2.02c1.01-.04,1.94.77,1.98,1.81.05,1.05-.76,1.93-1.81,1.98l-48.64,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M557.07,1292.88c-.19,0-.39-.03-.58-.09l-41.6-13.28,10.38-24.21,36.66,13.25c.99.36,1.49,1.44,1.14,2.43-.36.98-1.44,1.51-2.43,1.14l-33.29-12.03-7.32,17.09,37.62,12c1,.32,1.55,1.39,1.23,2.38-.26.8-1,1.32-1.81,1.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "749.62 401.91 746.89 412.12 735.96 453.43 728.58 481.14 662.85 457.53 694.55 392.65 710.03 370.31 749.62 401.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M746.89,412.12l-10.92,41.31c-19.37-21.03-15.42-47.28-15.42-47.28l26.34,5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M798.93,343.78s-4.21,93.54-51.41,85.53-46.35-88.48-46.35-88.48l61.52-19.8,36.24,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M733.41,357.89s27.07-27.91,65.52-14.12c0,0,16.96,7.16,23.6-6.74,0,0-54.35-72.05-97.02-37.29,0,0-76.48,16.75-30.97,92.91l38.87-34.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 734.24,
    cy: 360,
    rx: 14.52,
    ry: 16.64,
    transform: "translate(-47.53 120.11) rotate(-9.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 792.19,
    cy: 390.97,
    r: 8.43,
    transform: "translate(279.68 1110.52) rotate(-80.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 759.54,
    cy: 382.33,
    r: 14.54
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1032.36,533.62s8.7,11.93-9.05,23.87c0,0,14.11,9.66-34.53,25.58-5.41,1.77-11.58,3.59-18.66,5.51l-19.52-70.89s86.82-29.33,88.99-19.92c2.17,9.4-15.52,22.1-15.52,22.1,0,0,31.1-7.63,8.29,13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M950.61,517.68l-102.8,13.17s-147.9-105.34-178.23-95.23-132.73,174.44-132.73,174.44c0,0-27.81,8.85-26.55,20.22,1.26,11.38,180.76,104.5,204.78,80.9,15.1-14.84,32.44-133.15,32.44-133.15l65.41,27.21c19.39,8.07,40.82,9.89,61.3,5.22l95.91-21.88-19.54-70.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M944.11,581.01c-3.53-13.8-6.98-27.27-10.11-40.23-.87-3.61-1.67-7.29-2.47-10.99-.68-3.13-1.38-6.27-2.12-9.4l-3.78.48c.76,3.23,1.49,6.48,2.19,9.72.81,3.73,1.61,7.44,2.5,11.08,3.14,12.97,6.59,26.45,10.12,40.27,1.08,4.21,2.16,8.45,3.24,12.69l3.7-.84c-1.09-4.27-2.18-8.54-3.26-12.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M768.12,478.27c-1.56.33-3.12.68-4.69,1.01-28.49,5.94-58.96,10.74-88.77,5.7-15.11-2.56-29.01-7.79-40.86-15.06-.8.98-1.59,1.95-2.4,2.97,12.36,7.66,26.87,13.16,42.63,15.83,30.42,5.15,61.32.29,90.17-5.72,2.86-.6,5.72-1.23,8.58-1.85-1.55-.96-3.1-1.92-4.67-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M728.74,660.4c-8.56.71-17.41,1.44-26.01.64-25.25-2.35-47.65-18.06-62.31-29.68-5.19-4.12-10.28-8.39-15.37-12.67-12.94-10.88-26.32-22.12-41.38-30.51-8.69-4.83-17.51-8.26-26.18-10.38-.75,1.15-1.45,2.22-2.16,3.33,8.74,2,17.68,5.47,26.5,10.37,14.74,8.21,27.98,19.33,40.79,30.1,5.11,4.3,10.23,8.6,15.45,12.74,15.03,11.91,38.05,28.03,64.31,30.48,8.93.82,17.95.08,26.67-.64.86-.07,1.73-.11,2.59-.18.3-1.28.59-2.57.88-3.86-1.26.1-2.52.16-3.79.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M747.53,578.05l-26.63-11.68s6.8,42.3,19.64,48.35l6.99-36.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M988.78,583.07c-5.41,1.77-11.58,3.59-18.66,5.51l-19.52-70.89,38.17,65.38Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2158.64,1010.78l61.94,27.81,46.16-151.94-60.46-15.89c-15.98,35.72-32.27,81.43-47.64,140.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2206.28,870.76l60.46,15.89,51.6-141.74s-62.36-8.43-112.05,125.85Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2132.94 958.11 2088.28 1081.15 2255.13 1145.19 2288.84 1017.1 2132.94 958.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2187.83,1122.07c-1.22,3.48-11.2,7.64-17.61,1.95-12.49-2.21-20.92-3.79-28.71-12.4-7-2.69-10.14-10.3-6.94-16.72,6.13-12.29,15.62-29.61,20.14-28.92,5.67.86,1.57,18.35,1.57,18.35,0,0,9.45-22.2,18.41-19.26,4,1.31-5.62,22.45-6.59,24.67,1.51-2.02,13.5-18.15,18.09-14.76,4.59,3.44-6.59,22.5-7.77,24.52,1.3-1.62,11.82-14.31,16.95-10.11,2.22,1.86-1.27,14.75-7.53,32.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2501.2,1545.48s80.9-8.85,115.03-83.43l-89.75,5.06-25.28,78.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "2590.53 1462.9 2513 1510.93 2547.88 1562.16 2622.64 1511.22 2590.53 1462.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2670.59 1583.4 2622.64 1511.22 2547.88 1562.16 2560.61 1580.87 2553.03 1680.74 2670.59 1583.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 2560.59,
    y: 1577.39,
    width: 38.01,
    height: 5.05,
    transform: "translate(-76.93 133.09) rotate(-2.91)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "2369.74 1599.41 2284.63 1594.36 2284.63 1663.27 2376.19 1657.46 2369.74 1599.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2284.63 1663.27 2284.63 1679.47 2220.58 1743.52 2385.75 1743.52 2376.19 1657.46 2284.63 1663.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 2298.3,
    y: 1670.3,
    width: 5.06,
    height: 41.94,
    transform: "translate(-317.11 2831.71) rotate(-59.86)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2365.44,1159.44c-1.31,31.35-1.57,64.42-1.01,97.74.51,28.92,1.57,58.05,3.08,86.51,7.28,141.42,24.12,266.67,24.12,266.67l-131.46,16.89c-62.34-434.84-21.89-618.58-21.89-618.58l57.29-11.68,50.87-10.37,57.03-11.63c-.71,1.06-1.42,2.17-2.07,3.34-8.7,14.21-15.57,33.12-20.88,55.57-8.34,34.94-12.99,78.32-15.07,125.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2367.52,1343.69c-55.11-117.15-34.43-210.29-34.43-210.29l32.36,26.04c-1.31,31.35-1.57,64.42-1.01,97.74.51,28.92,1.57,58.05,3.08,86.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2616.23,1462.05c-63.2,24.02-115.03,83.43-115.03,83.43-54.56-96.42-101.13-193.25-136.77-288.31-29.68-79.08-51.78-156.95-64.57-232.28-1.57-9.35-3.03-18.66-4.3-27.91-.15-.86-.3-1.77-.4-2.63l51.27-7.74,54.96-8.29,27.76-4.2c2.98,17.7,6.98,36.2,11.78,55.26,47.83,190.32,175.3,432.66,175.3,432.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2505.02,1219.63c-.8-2-1.61-3.99-2.4-6-10.36-6.63-20.27-13.91-28.8-22.67-23.83-24.45-35.89-60.66-31.45-94.51,1.37-10.43,4.31-20.66,8.57-30.35-.54-1.84-1.06-3.68-1.59-5.52-5.42,11.18-9.15,23.15-10.75,35.37-4.58,34.98,7.88,72.4,32.5,97.65,10.02,10.27,21.77,18.53,33.92,26.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2571.16,1370.63c-.53-1.12-1.06-2.24-1.59-3.38-13.95,5.7-30.66,6.68-48.01,7.66-17.51.99-35.61,2.02-51.49,8.21-16.13,6.29-28.64,17.51-37.72,31.27.65,1.34,1.31,2.68,1.96,4.02,8.77-14.01,21.06-25.48,37.14-31.75,15.32-5.97,33.11-6.98,50.32-7.96,17.11-.97,34.58-2,49.38-8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2268.29,1356.23c42.05,21.35,76.12,57.14,106.23,90.71-.17-2.07-.34-4.15-.51-6.24-29.52-32.73-62.91-66.99-104.01-87.85-13.12-6.66-26.62-11.55-40.1-14.68.08,1.32.16,2.64.24,3.97,12.81,3.07,25.65,7.75,38.14,14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2384.59,1551.28c-10.52,2.51-22.03,1.88-31.53-.35-9.89-2.32-19.58-6.15-28.96-9.85-9.98-3.95-20.31-8.02-31.03-10.36-14.94-3.26-30.59-2.86-45.5.73.15,1.25.31,2.53.46,3.79,14.48-3.55,29.71-3.99,44.23-.82,10.42,2.28,20.61,6.3,30.45,10.19,9.51,3.75,19.33,7.63,29.48,10.01,9.86,2.31,21.78,2.97,32.82.44-.14-1.23-.28-2.52-.42-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2256.89,1195.31c1.38,26.48-10.63,52.53-30.39,69.75.05,1.6.11,3.25.17,4.87,22-17.92,35.5-46.15,34-74.82-1.33-25.49-14.46-49.37-34.05-65.28-.06,1.57-.12,3.17-.18,4.77,17.55,15.2,29.21,37.24,30.44,60.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2440.93,1029.39c-20.12,3.64-40.6,4.8-60.42,4.5-29.48-.51-57.44-4.4-80.65-9-36.71-7.23-61.59-16.23-61.59-16.23l57.29-11.68c-.15-.86-.3-1.77-.4-2.63l51.27-7.74,57.03-11.63c-.71,1.06-1.42,2.17-2.07,3.34l27.76-4.2c2.98,17.7,6.98,36.2,11.78,55.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2364.43,1259.7c-1.04,0-2.01-.65-2.38-1.68l-36.52-102.71-43.9-26.5c-1.19-.72-1.58-2.28-.85-3.47.73-1.19,2.29-1.57,3.47-.85l45.44,27.43,37.13,104.4c.47,1.32-.22,2.77-1.53,3.23-.28.1-.57.15-.85.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2450.64,993.74c-84.69,32.21-230.06,14.11-230.06,14.11,5.92-61.53,6.32-243.56,101.13-266.31l42.37,4.45c22.2,8.7,39.54,41.87,52.59,81.25,7.84,23.46,14.11,49.15,19.06,73.21,10.42,50.31,14.92,93.29,14.92,93.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2435.73,900.45c-39.89-23.21-48.29-75.49-48.29-75.49l29.23,2.28c7.84,23.46,14.11,49.15,19.06,73.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2364.05,745.96l-5.69,81.53,87.02,46.47,17.62-84.47c-76.51-45.2-98.95-43.53-98.95-43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2529.82,858.03c-2.07,3.13-4.4,6.07-7.03,8.75-4.75,4.96-10.37,9-16.64,12.03-9.25,4.5-19.37,6.42-29.38,5.81-8.39-.51-16.64-2.83-24.27-6.88l-7.13-3.79,17.65-84.49c4.7,2.83,9.61,5.76,14.81,8.95,0,0,68.87-97.33,73.92-95.41,4.55,1.67-3.19,16.74-4.75,19.72,2.98-4.4,25.33-37.16,31.3-34.89,4.75,1.77-1.26,16.33-2.02,18.1,1.37-1.97,13.35-19.62,20.58-15.37,3.34,1.97-9.56,21.08-10.82,23.01,1.57-1.52,15.88-15.37,19.42-11.22,3.64,4.2-10.26,20.73-11.83,22.6,1.42-1.26,13.65-11.93,17.55-6.78,5.11,6.62-57.49,103.45-81.36,139.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2522.79,866.78c-4.75,4.96-10.37,9-16.64,12.03-9.25,4.5-19.37,6.42-29.38,5.81-.45-1.82-.66-3.69-.66-5.61,0-13.75,11.17-24.93,24.93-24.93,9.3,0,17.44,5.11,21.74,12.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2311.7,990.72c-37.37,0-70.86-2.39-87.28-3.8-1.12-.1-1.8-.16-1.98-.16-1.03-.05-1.86-.91-1.83-1.94.02-1.03.84-1.85,1.88-1.85.13,0,.9.06,2.26.18,37.43,3.21,164,11.58,221.31-15.17.93-.44,2.08-.03,2.52.92.44.95.03,2.08-.92,2.52-32.8,15.3-87.62,19.31-135.95,19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2331.55,799.02c-20.11,0-29-13.28-29.13-13.48-.56-.88-.31-2.05.56-2.61.88-.57,2.04-.32,2.62.56.66,1,16.53,24.32,56.5,2.73.92-.48,2.06-.15,2.57.77.5.92.15,2.07-.77,2.57-12.98,7.01-23.71,9.47-32.35,9.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2398.11,587.47c10.62-5.97,24.95-6.51,34.36,1.22,4.91,4.03,8.06,9.81,12.62,14.24,9.77,9.49,24.96,11.87,34.32,21.77,7.23,7.64,9.81,18.79,9.09,29.28-.73,10.49-4.41,20.54-8.33,30.3-5.59,13.94-12.04,28.1-23.21,38.14-4.27,3.84-9.27,7.04-14.86,8.32-5.59,1.29-11.84.46-16.39-3.03-4.8-3.69-7.17-9.87-7.58-15.92s.87-12.06,2.15-17.98c3.05,1.88,7.17,1.84,10.19-.09s4.78-5.66,4.35-9.21c-.72-6.03-6.67-9.82-12-12.74-8.83-4.84-17.66-9.68-26.5-14.52-5.17-2.83-10.45-5.75-14.34-10.18-6.5-7.4-11.71-23.68-7.41-33.02,4.77-10.37,13.55-20.97,23.52-26.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2293.27,636.62s-.54-59.91,73.86-44.12c12.59,2.67,23.6,9.46,31.69,19.47,12.11,14.98,19.86,77.96-14.75,95.44-43.4,21.91-90.8-70.79-90.8-70.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2370.35,687.18l-1.72,60.17c-.46,15.27-12.54,27.66-27.81,28.47-.51.05-1.01.05-1.52.05-17.09,0-30.69-14.66-29.23-31.9l.1-.96,3.94-45.71,5.01-.91,51.22-9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2344.86,708.67s-9.3,23.16-34.69,34.33l3.94-45.71,5.01-.91,25.74,12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2293.27,636.62s-18.96,79,20.86,82.8c39.82,3.79,56.25-32.23,56.25-32.23l5.06-44.87-24.65-35.39-39.19,12.01-18.33,17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2293.27,636.62s36.63-20.55,49.93,6.95c9.27,19.17,23.39,29.71,37.29,23.39,13.9-6.32,2.53-51.83,2.53-51.83l-51.83-13.27-30.97,17.7-6.95,17.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 2369.9,
    cy: 668.71,
    rx: 17.31,
    ry: 14.31,
    transform: "translate(605.81 2386.73) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2365.95,675.6s-.06,0-.09,0c-.69-.05-1.21-.65-1.17-1.35.32-4.49,3.16-12.97,11.58-12.97.7,0,1.26.57,1.26,1.26s-.57,1.26-1.26,1.26c-8.18,0-9.03,10.19-9.07,10.63-.05.66-.6,1.17-1.26,1.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2299.3,664.99c0,1.78-1.44,3.23-3.23,3.23s-3.23-1.44-3.23-3.23,1.44-3.23,3.23-3.23,3.23,1.44,3.23,3.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 2320.76,
    cy: 664.74,
    r: 3.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2306.05,684.67c-2.8,0-4.7-.88-5.65-2.62-2.5-4.56,3.29-13.11,4.48-14.78.4-.57,1.19-.7,1.77-.3.57.4.7,1.19.3,1.76-3.08,4.32-5.56,9.86-4.33,12.09.53.97,1.92,1.39,4.07,1.29.02,0,.05,0,.07,0,.67,0,1.22.52,1.26,1.2.03.7-.5,1.29-1.19,1.33-.27.01-.52.02-.77.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 2338.69,
    cy: 679.2,
    r: 11.3,
    transform: "translate(-81.9 946.68) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2307.62,695.61c-3.41,0-5.77-1.19-5.95-1.28-.62-.32-.86-1.08-.54-1.7.32-.62,1.08-.87,1.7-.55.29.15,7.11,3.5,14.17-3,.52-.47,1.31-.43,1.79.08.47.51.43,1.31-.08,1.79-4,3.68-7.98,4.66-11.09,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2303.15,657.86c-2.38-.51-4.54-1.19-6.54-1.16-1-.07-1.93.06-2.88.32-1,.16-1.9.7-3.08,1.16l-.12.05c-.4.15-.85-.04-1-.44-.08-.2-.07-.41.01-.59.56-1.27,1.51-2.47,2.85-3.21,1.31-.72,2.87-1.1,4.35-1.04,2.95.27,5.56,1.49,7.28,3.72.26.34.2.82-.14,1.08-.18.14-.41.19-.63.14l-.11-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2312.52,656.77c1.75-3.03,4.95-5.15,8.75-5.55,1.88-.13,3.84.29,5.43,1.21,1.62.89,2.85,2.21,3.74,3.68.22.36.1.83-.26,1.05-.22.13-.48.14-.7.05l-.08-.04c-1.47-.64-2.72-1.38-4.05-1.71-1.27-.47-2.55-.59-3.83-.49-2.58.05-5.22,1.37-7.91,2.8l-.09.05c-.37.2-.82.06-1.02-.31-.13-.24-.11-.51.01-.73Z"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 109.6,
    y: 1740.99,
    width: 2806.22,
    height: 5.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarBusiness);
export default __webpack_public_path__ + "static/media/mar-business.0ff71c26b7c7bbd93b7f8bb4611de668.svg";
export { ForwardRef as ReactComponent };